/**
 * @namespace Pjax
 * @aka COMMON.Pjax
 *
 */
COMMON.Pjax = (function ($) {
  if (!$.support.pjax || "undefined" !== typeof window.isFractal) {
    return;
  }

  $.pjax.defaults.scrollTo = 0;
  $.pjax.defaults.timeout = 30000;
  $.pjax.defaults.container = "#content";
  $.pjax.defaults.fragment = "#content";
  $.pjax.defaults.maxCacheLength = 0;

  $(document).on('click', '[data-spy=pjax]', function (event) {
    var $element = $(this);

    if (true === ($element.data('pjaxLoaded'))) {
      // Inhalt wurde bereits geladen
      return;
    }
    if (true === ($element.data('pjaxLoading'))) {
      // Es wird noch geladen
      return;
    }
    $element.data('pjaxLoading', true);

    var options = {
      push: $element.data('push') || false,
      url: $element.data('src'),
      scrollTo: false
    };

    if ('undefined' === typeof options.url) {
      $element.data('pjaxLoading', null);
      // todo: atm it breaks here
      return;
    }

    if ('' !== $element.data('target') || '') {
      //options.container = $element.data('target');
      //options.fragment = $element.data('target');
      if (false !== ($element.data('scrollTo') || false)) {
        options.scrollTo = $($element.data('target')).offset().top - $('#header').outerHeight()
      }
    }

    if (false !== ($element.data('replace') || false)) {
      options.replace = true;
    }

    $element
      .on('pjax:complete', function () {
        $element.data('pjaxLoading', null)
      })
      .on('pjax:success', function () {
        if ('undefined' === typeof $element.attr('href')) {
          $element.data('pjaxLoaded', true)
        }
      });

    $.pjax(options);
  });

  $(document).on('click', 'a', function (event) {
    var options = {};
    var $target = $(event.currentTarget);
    var href = $target.attr('href');

    if (!href || '#' === href.charAt(0) || !href.match("(/|\.html?)([?#]|$)") || href.indexOf('/-/') !== -1)
      return void (0);

    if ($target.attr('download') !== undefined)
      return void (0);

    if ($target.attr('data-keymatch') !== undefined)
      return void (0);

    if ($target.attr('target') && -1 !== $target.attr('target').indexOf('_blank'))
      return void (0);

    if ($target.attr('rel') && -1 !== $target.attr('rel').indexOf('external'))
      return void (0);

    if (0 !== $target.closest('li[data-external="true"]').length)
      return void (0);

    if ((new RegExp('~(rss|atom|podcast)')).test($target.attr('href')))
      return void (0);

    // https://jira.ard.de/browse/SOS-25009: Hotfix, um PJAX bei Liveblogs abzuschaltent
    if ((new RegExp('/.+~.*_?ts-[0-9]+')).test($target.attr('href')))
      return void (0);

    abortXhr(window.jQuery.pjax.xhr);

    if ('' !== $target.data('target') || '') {
      //options.container = $target.data('target');
      //options.fragment = $target.data('target');
      if (false !== ($target.data('scrollto') || false)) {
        options.scrollTo = $($target.data('target')).offset().top - $('#header > *').outerHeight()
      }
    }

    if (false !== ($target.data('replace') || false)) {
      options.replace = true;
    }

    if (usePjax(options)) {
      $.pjax.click(event, options);
    }

    $(document).one('pjax:end', function (event, xhr, options) {
      $target.blur()
    })
  });

  $(document).on('submit', 'form', function (event) {
    if (false == $(event.target).data('pjax')) {
      return;
    }

    // TODO: das ist jetzt gedoppelt aus swr/form-submit.js -> geht das auch schöner?
    $(event.target).find("[type=submit][data-disable-on-submit=true]").each(function (index, element) {
      if($(event.target).attr('novalidate')){
        //Ein UGC-Formular hat seine eigene "Button"-Disable-Funktion
        console.log("UGC-Formular");
        return;
      }
      if (this.hasAttribute("data-text-after-submit")) {
        if (this.tagName === "BUTTON") {
          this.textContent = this.getAttribute("data-text-after-submit");
        } else {
          this.value = this.getAttribute("data-text-after-submit");
        }
      }
      this.disabled = true;
    });

    abortXhr(window.jQuery.pjax.xhr);

    var element = $(event.currentTarget).data('target');

    if ('undefined' !== typeof element) {
      $.pjax.submit(event, element, '#content', {
        //fragment: element,
        scrollTo: false,
        push: false
      });
    } else {
      $.pjax.submit(event, {
        scrollTo: false
      });
    }
  });

  function usePjax(options) {
    if (options.container || '' !== '') {
      return true
    }

    return !(document.location.host.match(/(www|standby)\.swrfernsehen\.de/)
      || document.location.host.match(/(www|standby)\.herzenssache\.de/)
      || (document.location.host.match(/.*(-vorschau\d).*/) && !document.location.pathname.match(/(\/cms\/)?\/dasding\/.*/)))
  }

  function findAll(elems, selector) {
    return elems.filter(selector).add(elems.find(selector))
  }

  function parseHTML(html) {
    return $.parseHTML(html, document, false)
  }


  /**
   * Canonical aktualisieren
   */
  var canonicalCache = {};

  function updateCanonicalCache(url) {
    canonicalCache[document.location.pathname] = url
  }

  $(function () {
    updateCanonicalCache($('link[rel=canonical]').first().attr('href'))
  });

  /**
   * Favicon aktualisieren
   */
  var faviconCache = {};

  function updateFaviconCache(favhref) {
    faviconCache[document.querySelector("link[rel*='icon']")] = favhref
  }

  $(function () {
    updateFaviconCache($('link[rel="icon"]').first().attr('href'))
  });

  /**
   * Manifest aktualisieren
   */
  var manifestCache = {};

  function updateManifestCache(manihref) {
    manifestCache[document.querySelector("link[rel*='manifest']")] = manihref
  }

  $(function () {
    updateManifestCache($('link[rel="manifest"]').first().attr('href'))
  });

  /**
   * meta[name="swr:id"] aktualisieren
   */
  var swrIdCache = {};

  function updateSwrIdCache(value) {
    swrIdCache[document.querySelector("meta[name*='swr:id']")] = value
  }

  $(function () {
    updateSwrIdCache($('meta[name="swr:id"]').first().attr('content'))
  });

  /**
   * Klasse für body aktualisieren
   */
  var bodyClassCache = {};

  function updateBodyClassCache(className) {
    var bodyClassesBeforeSubmit = $("body").attr("class");
    if (bodyClassesBeforeSubmit.indexOf("zam") > -1 && className.indexOf("zam") === -1) {
      className = "zam " + className;
    }
    bodyClassCache[document.location.pathname] = className;
  }

  $(function () {
    updateBodyClassCache($('body').attr('class'))
  });

  /**
   * Klasse für body aktualisieren
   */
  var bodyDataSectionCache = {};

  function updateBodyDataSectionCache(DataSectionName) {
    bodyDataSectionCache[document.location.pathname] = DataSectionName
  }

  $(function () {
    updateBodyDataSectionCache($('body').attr('data-menubox-filter-section'))
  });

  /**
   * Klasse für #content aktualisieren
   */
  var containerClassCache = {};

  function updateContainerClassCache(className) {
    containerClassCache[document.location.pathname] = className
  }

  $(function () {
    updateContainerClassCache($('#content').attr('class'))
  });

  /**
   * Navigation (im Header) bei PJAX-Requests aktualisieren
   */
  var navigationCache = {};

  function updateNavigationCache(id) {
    navigationCache[document.location.pathname] = id
  }

  $(function () {
    updateNavigationCache($('#header').find('.nav li.active').attr('id'))
  });

  /**
   * Klasse für body aktualisieren
   */
  var bodyStationIdCache = {};

  function updateBodyStationIdCache(stationid) {
    bodyStationIdCache[document.location.pathname] = stationid
  }

  $(function () {
    updateBodyStationIdCache($('body').attr('data-stationid'))
  });

  $(document).on("pjax:success", function (event, data, status, xhr, options) {
    //var doc_tree = $.parseHTML(data, document.implementation.createHTMLDocument('tmp'), false);

    var fullDocument = /<html/i.test(data);
    var $head, $body;

    // Attempt to parse response html into elements
    if (fullDocument) {
      $body = $(parseHTML(data.match(/<body[^>]*>([\s\S.]*)<\/body>/i)[0]));

      var head = data.match(/<head[^>]*>([\s\S.]*)<\/head>/i);
      $head = head !== null ? $(parseHTML(head[0])) : $body
    } else {
      $head = $body = $(parseHTML(data))
    }

    try {
      var canonical = findAll($head, 'link[rel="canonical"]').last().attr('href');
      updateCanonicalCache(canonical);
    } catch (e) {
    }

    try {
      var navId = findAll($head, 'meta[http-equiv="x-current-nav-item"]').last().attr('content');
      updateNavigationCache(navId);
    } catch (e) {
    }

    try {
      var faviconHref = findAll($head, 'link[rel="icon"]').last().attr('href');
      updateFaviconCache(faviconHref);
    } catch (e) {
    }

    try {
      var manifestHref = findAll($head, 'link[rel="manifest"]').last().attr('href');
      updateManifestCache(manifestHref);
    } catch (e) {
    }

    try {
      var value = findAll($head, 'meta[name="swr:id"]').last().attr('content');
      updateSwrIdCache(value);
    } catch (e) {
    }

    try {
      // findAll entfernt bestimmte Tags wie das <body>-Tag aus der Rückgabe, deshalb hier nicht verwendbar
      //var className = data.match(/<body class="([^>]+)">/i)[1];

      // start: tmp trick to be able to parse body with JS
      var body_start = data.indexOf('<body') + 5;
      var body_end = data.indexOf('</body') - 6;
      var $body_parse = data.substr(body_start, body_end - body_start);
      $body_parse = $('<div ' + $body_parse + '</div>');
      // end: tmp trick to be able to parse body with JS
      var className = $body_parse.attr('class');
      var sectionName = $body_parse.attr('data-menubox-filter-section');
      updateBodyClassCache(className);
      updateBodyStationIdCache($body_parse.attr('data-stationid'));
      updateBodyDataSectionCache(sectionName);
    } catch (e) {
      console.error(e);
    }

    try {
      var containerClassName = findAll($body, '#content').attr('class');
      updateContainerClassCache(containerClassName);
    } catch (e) {
    }

  });

  $(document).on('pjax:end', function (event, xhr, options) {
    // Updating new HTML with classes and info from caches
    try {
      if (0 === $('link[rel=canonical]').length) {
        var $linkElement = $('<link />');
        $linkElement.attr('rel', 'canonical');
        $linkElement.attr('href', document.location.pathname);
        $linkElement.appendTo('head');
      } else {
        $('link[rel=canonical]').last().attr('href', canonicalCache[document.location.pathname]);
      }
    } catch (e) {
    }

    try {
      $('link[rel="icon"]').first().attr('href', faviconCache[document.querySelector("link[rel*='icon']")]);
      $('link[rel="manifest"]').first().attr('href', manifestCache[document.querySelector("link[rel*='manifest']")]);
    } catch (e) {
    }

    try {
      $('#header').find('.nav li.active').removeClass('active');
      $('#' + navigationCache[document.location.pathname]).addClass('active');
    } catch (e) {
    }

    try {
      $('body').attr('class', bodyClassCache[document.location.pathname]);
      // add data-menubox-filter-section both ways to ensure that jQuery.data() cache is invalidated and every other script is able to read it also
      $('body').attr('data-menubox-filter-section', bodyDataSectionCache[document.location.pathname]);
      $('body').attr('data-stationid', bodyStationIdCache[document.location.pathname]);
      $('body').data('menuboxFilterSection', bodyDataSectionCache[document.location.pathname]);
    } catch (e) {
    }

    try {
      $('#content').attr('class', containerClassCache[document.location.pathname]);
    } catch (e) {
    }

    // lazyload
    try {
      if ('undefined' !== typeof window.lazyLoadInstance && 'undefined' !== typeof window.lazyLoadInstance.update) {
        window.setTimeout(function () {
          window.lazyLoadInstance.update();
        }, 50);
      }
    } catch (e) {
    }
  });

  $(document).on('pjax:timeout', function (event, xhr, options) {
    // Prevent default timeout redirection behavior
    event.preventDefault();
  });

  $(document).on('pjax:error', function (event, xhr, textStatus, errorThrown, options) {
    if (!options.push) {
      // In diesem Fall wollen wir keinen Seitenreload
      event.preventDefault();
    }

    options.success(xhr.responseText, textStatus, xhr);
    return false;
  });

  $(document).on('pjax:start', function (event, xhr, options) {
    $(document).trigger('loader.show');
  });

  $(document).on('pjax:end', function (event, xhr, options) {
    $(document).trigger('loader.hide');
  });

  function abortXhr(xhr) {
    if (xhr && xhr.readyState < 4) {
      xhr.onreadystatechange = $.noop;
      xhr.abort()
    }
  }

  $(document).on('click', '[data-pjax-reload]', function (event) {
    var options = {
      scrollTo: 0
    }

    var target;
    var targetSelector = $(this).data('scrollTo');

    if (targetSelector) {
      target = document.querySelector(targetSelector);
    }

    if (target) {
      options.scrollTo = $(target).offset().top - $('#header').outerHeight()
    }

    $.pjax.reload('#content', options)
  });

  /*
   * Public API
   */
  var Pjax = {
    // noop
  };
  return Pjax;

})(window.jQuery);

/**
 * SOS-25520
 * iOS nutzt für das Sharing offenbar bevorzugt OpenGraph-Elemente, daher müssen sie entfernt werden
 */
(function ($) {

  $(document).one('pjax:end', function () {
    $('meta[property^=og\\:]').remove()
    $('meta[name^=twitter\\:]').remove()
  });

})(window.jQuery)
